import React from "react";
import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import { signatureServices } from "../data/signatureServices";
import { ContactForm } from "../components/ContactForm";
import { SectionLabel } from "../components/SectionLabel";
import { ledgerEase } from "../utils/motion";
const nextSteps = ["A reply from a senior operator within one business day.", "A working conversation about your payroll, your systems, your people, and your dates.", "A written view of what we would do first, whether or not you engage us."];
export function Contact() {
  const [params] = useSearchParams();
  const service = signatureServices.find(s => s.id === params.get("service"));
  return <section className="shell pb-28 pt-20 md:pb-36 md:pt-28" data-id="element-712" data-mp="12y7h1xywa5kr">
      <div className="grid grid-cols-12 gap-x-6 gap-y-16" data-id="element-713" data-mp="f9o6fbsdhgpi">
        <div className="col-span-12 lg:col-span-5" data-id="element-714" data-mp="f83cnodvu1sp">
          <SectionLabel data-id="element-715" data-mp="aa1v57w3uajc">Contact</SectionLabel>
          <motion.h1 initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: ledgerEase
        }} className="mt-8 font-display text-[clamp(3rem,7vw,6.5rem)] leading-[0.98] tracking-[-0.015em] text-navy" data-id="element-716" data-mp="a90ix03cri01">
            Talk to us.
          </motion.h1>
          <p className="mt-8 max-w-md text-lg leading-relaxed text-charcoal/80" data-id="element-717" data-mp="1j73drt9bolkg">
            Tell us what’s happening with your payroll or HR technology. A senior operator — not a sales team — will
            read it and reply.
          </p>

          <a href="mailto:hello@constantpayroll.com" className="mt-10 inline-block break-all border-b border-navy pb-1 font-display text-2xl text-navy transition-colors duration-150 hover:border-oxblood hover:text-oxblood" data-id="element-718" data-mp="qifzwiqwkygx">
            hello@constantpayroll.com
          </a>

          <div className="mt-16" data-id="element-719" data-mp="26yscpsgng8ad">
            <p className="eyebrow text-charcoal/70" data-id="element-720" data-mp="2buzinl91pjsb">What happens next</p>
            <ol className="mt-5 border-t border-stone" data-id="element-721" data-mp="1m7dc3eykxhgf">
              {nextSteps.map((step, i) => <li key={step} className="flex gap-5 border-b border-stone py-4" data-id="element-722" data-mp="1h8agel4honl4" data-mpi={i}>
                  <span className="w-6 shrink-0 font-display tabular-nums text-oxblood" data-id="element-723" data-mp="1had8rbt46st0">{i + 1}</span>
                  <span className="text-[15px] leading-relaxed text-charcoal/80" data-id="element-724" data-mp="1w36xzoy6unav">{step}</span>
                </li>)}
            </ol>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-6 lg:col-start-7 lg:pt-24" data-id="element-725" data-mp="13hdokwie0af4">
          <ContactForm key={service?.id ?? "general"} serviceName={service?.name} initialValues={service ? {
          mode: service.contactMode,
          area: service.contactArea
        } : undefined} data-id="element-726" data-mp="yiu2mw3smymr" />
        </div>
      </div>
    </section>;
}